import { Link } from 'react-router-dom';
import { RoomBackdrop } from '../components/RoomBackdrop';
import { ENGAGEMENTS } from '../data/engagements';
import './WorkPages.css';

export function WorkPage() {
  return (
    <>
      <RoomBackdrop room="work" dim={0} fit="contain" />
      <main className="page work">
        <header className="work__header">
          <h1 className="work__title">Selected engagements.</h1>
          <p className="work__lede">
            Proof from completed engagements — open one for the full breakdown.
          </p>
        </header>

        <div className="work__list" aria-label="Selected engagements">
          {ENGAGEMENTS.map((e) => (
            <Link key={e.slug} to={`/work/${e.slug}`} className="work-row">
              <div className="work-row__main">
                <h2 className="work-row__title">{e.title}</h2>
                <p className="work-row__chips">{e.chips.join(' · ')}</p>
                <p className="work-row__summary">{e.summary}</p>
              </div>
              <span className="work-row__open">Open →</span>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
